export const RESULT_STATE_GET_REQUEST = 'RESULT_STATE_GET_REQUEST';
export const RESULT_STATE_GET_SUCCESS = 'RESULT_STATE_GET_SUCCESS';
export const RESULT_STATE_GET_ERROR = 'RESULT_STATE_GET_ERROR';
export const RESULT_STATE_GET_BY_KEY_REQUEST = 'RESULT_STATE_GET_BY_KEY_REQUEST';
export const RESULT_STATE_GET_BY_KEY_SUCCESS = 'RESULT_STATE_GET_BY_KEY_SUCCESS';
export const RESULT_STATE_GET_BY_KEY_ERROR = 'RESULT_STATE_GET_BY_KEY_ERROR';
export const RESULT_STATE_ADD_REQUEST = 'RESULT_STATE_ADD_REQUEST';
export const RESULT_STATE_ADD_SUCCESS = 'RESULT_STATE_ADD_SUCCESS';
export const RESULT_STATE_ADD_ERROR = 'RESULT_STATE_ADD_ERROR';
export const RESULT_STATE_EDIT_REQUEST = 'RESULT_STATE_EDIT_REQUEST';
export const RESULT_STATE_EDIT_SUCCESS = 'RESULT_STATE_EDIT_SUCCESS';
export const RESULT_STATE_EDIT_ERROR = 'RESULT_STATE_EDIT_ERROR';
export const RESULT_STATE_DELETE_REQUEST = 'RESULT_STATE_DELETE_REQUEST';
export const RESULT_STATE_DELETE_SUCCESS = 'RESULT_STATE_DELETE_SUCCESS';
export const RESULT_STATE_DELETE_ERROR = 'RESULT_STATE_DELETE_ERROR';
